/**
 * @file        src/pages/flight/CorporateAmendmentMarkup.jsx
 * @description Corporate Flight → Amendment Markup. The B2C screen's component
 *              (AmendmentMarkup.jsx) fixed to audience=b2b.
 * @author      Kinetika Labs
 * @created     2026-10-10
 * @changelog
 *   - 2026-10-10 Claude — Initial.
 */
import AmendmentMarkup from './AmendmentMarkup';

export default function CorporateAmendmentMarkup() {
  return (
    <AmendmentMarkup
      title="Corporate Amendment Markup"
      subtitle="Corporate Flight · our markup on cancellation, void, refund, reschedule and add-ons"
      audience="b2b"
    />
  );
}
